import React, { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { decruptCipherJson } from "../../../utils/CommonLibrary";

const UserTabsContext = createContext();

export const UserTabsProvider = ({ children }) => {
  /*const [userTabs, setUserTabs] = useState([]);*/
  const navigate = useNavigate();

  const [userTabs, setUserTabs] = useState(() => {
    const savedTabs = localStorage.getItem("userTabs");
    return savedTabs ? JSON.parse(savedTabs) : [];
  });

  useEffect(() => {
    if (localStorage.getItem("dashboard")) {
      const menuArr = localStorage.getItem("dashboard")
        ? localStorage.getItem("dashboard")
        : "";
      const dashboard = decruptCipherJson(menuArr);

      if (dashboard.value == 5) {
        localStorage.setItem("userTabs", JSON.stringify(userTabs));
        if (userTabs.length === 0) {
          const profileOrigin = localStorage.getItem("profileOrigin");

          navigate("/tasklist");
          //   if (profileOrigin === "tasklist") {
          //   } else {
          //     navigate("/dashboard");
          //   }
        } else {
          navigate("/members/" + userTabs[userTabs.length - 1].userId);
        }

        let isLoggedIn = localStorage.getItem("authToken")
          ? localStorage.getItem("authToken")
          : "";
        if (isLoggedIn === "") {
          navigate(process.env.REACT_APP_LOGIN_URL);
        }
      }
    }
  }, [userTabs]);

  const addUserTab = (user) => {
    setUserTabs((prevTabs) => {
      // If tab already exists, just return previous tabs
      if (prevTabs.some((item) => item.userId === user.userId)) {
        return prevTabs;
      }
      // If less than 5, add new tab
      if (prevTabs.length < 5) {
        return [...prevTabs, user];
      }
      // If 5 tabs, remove the first (oldest) and add new tab
      return [...prevTabs.slice(1), user];
    });
  };

  const closeUserTab = (id) => {
    setUserTabs((prevTabs) => prevTabs.filter((tab) => tab.userId !== id));
  };

  return (
    <UserTabsContext.Provider value={{ userTabs, addUserTab, closeUserTab }}>
      {children}
    </UserTabsContext.Provider>
  );
};

export const useUserTabs = () => React.useContext(UserTabsContext);
